angular.module('app.filters')
.filter('trustAsResourceUrl', [
  '$sce', function($sce) {
    return function(val) {
      return $sce.trustAsResourceUrl(val);
    };
  }
]);


// WEBPACK FOOTER //
// ./scripts/shared/filters/trust-as-resource.js